/**
 * Luật "ghi được không" của một dòng nhập hoá đơn bằng AI.
 *
 * Bản sao luật backend (uniapp `utils/invoice-da-chi.util.js` và
 * `invoice-ocr.service#commitBatch`). Sửa một bên thì sửa cả bên kia: lệch
 * thì nút "Ghi N hoá đơn" nói dối — người dùng thấy 12 dòng sẵn sàng rồi
 * ghi ra 9.
 *
 * Ca khởi nguồn (10/2026): hoá đơn 00831156 đã chi cho TUANPNP, nhập lại bằng
 * AI, màn hình chỉ báo "Đã có", và Lưu đổi người nhận thành DUYNAPG.
 */

/**
 * Mã giữ chỗ backend tự điền khi chưa biết ai (INVOICE_OCR_DEFAULT_TEACHER).
 * Đổi khỏi nó không phải "đổi người nhận", nên không cần xác nhận.
 */
export const MA_MAC_DINH = 'HOANHST';

const sach = (v) => String(v || '').trim().toUpperCase();

/** Hoá đơn đã có, đang gán cho một người thật, và dòng này chọn người khác. */
export function canXacNhanDoiNguoi(item) {
  const cu = sach(item?.matchedTeacher);
  if (!cu || cu === MA_MAC_DINH) return false;
  return cu !== sach(item?.drivingTeacher);
}

export function gheDuoc(item) {
  return item.status === 'extracted'
    && !!item.reviewed
    && !!item.drivingTeacher
    && item.matchStatus !== 'duplicate'
    && item.matchStatus !== 'unidentifiable'
    // Đã chi thì backend luôn bỏ qua, kể cả khi đã tick xác nhận.
    && !item.matchedPaid
    && (!canXacNhanDoiNguoi(item) || !!item.confirmTeacherChange);
}
